<template>
  <div class="userOrder">
    <div class="userOrder-box">
      <!-- <h1 class="userOrder-title">我的订单</h1>
      <div class="userOrder-link">
        <router-link to="">
          <div class="link-box">
            <div class="img-box">
              <img src="~@/assets/image/user/toBePaid.png" alt="">
            </div>
            <div class="text">待支付</div>
          </div>
        </router-link>
        <router-link to="">
          <div class="link-box">
            <div class="img-box">
              <img src="~@/assets/image/user/paid.png" alt="">
            </div>
            <div class="text">已支付</div>
          </div>
        </router-link>
        <router-link to="">
          <div class="link-box">
            <div class="img-box">
              <img src="~@/assets/image/user/completed.png" alt="">
            </div>
            <div class="text">已完成</div>
          </div>
        </router-link>
        <router-link to="">
          <div class="link-box">
            <div class="img-box">
              <img src="~@/assets/image/user/cancelled.png" alt="">
            </div>
            <div class="text">已取消</div>
          </div>
        </router-link>
      </div> -->
      <router-link :to="orderlistPath">
        <img class="personal-information" src="~@/assets/image/user/personal_information.png" alt="">
        <span>My order</span>
      </router-link>
      <!-- <router-link to="/userOftenContactsList">
        <img class="my-order" src="~@/assets/image/user/my_order.png" alt="">
        <span>常用游客</span>
      </router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "userOrder",
  props: ['orderlistPath']
};
</script>

<style scoped lang='less'>
.userOrder{
  position: relative;
  padding: 1.253333rem .266667rem 0;
  .userOrder-box{
    position: absolute;
    height: 3.08rem;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    top: -3.08rem + 1.253333rem;
    width: 9.466667rem;
    background: #FFFFFF;
    box-shadow: 0 .026667rem .053333rem 0 rgba(4, 7, 5, 0.07);
    border-radius: .213333rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .266667rem;
    a {
      width: 4.333333rem;
      height: 1.56rem;
      background: #F8F8F8;
      border-radius: .213333rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        height: .666667rem;
      }
      span{
        font-size: .48rem;
        font-weight: bold;
        color: #333333;
        line-height: .666667rem;
        margin-left: .266667rem;
      }
    }
    // flex-direction: column;
    // .userOrder-title{
    //   font-size: .48rem;
    //   line-height: .666667rem;
    //   padding: .36rem .533333rem .453333rem;
    // }
    // .userOrder-link{
    //   display: flex;
    //   flex: 1;
    //   a{
    //     flex: 1;
    //     display: flex;
    //     justify-content: center;
    //     &:nth-child(2){
    //       .link-box{
    //         img{
    //           width: .8rem;
    //         }
    //       }
    //     }
    //     .link-box{
    //       display: inline-block;
    //       text-align: center;
    //       .img-box{
    //         height: .746667rem;
    //         display: flex;
    //         align-items: center;
    //         justify-content: center;
    //         img{
    //           width: .72rem;
    //         }
    //       }
    //       .text{
    //         font-size: .32rem;
    //         color: #333333;
    //         line-height: .44rem;
    //         margin-top: .16rem;
    //       }
    //     }
    //   }
    // }
  }
}
</style>
